import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	tests: [],
	currentTest: null,
	executions: [],
	recording: false,
	loading: false,
	error: null,
};

const testSlice = createSlice({
	name: "test",
	initialState,
	reducers: {
		setTests: (state, action) => {
			state.tests = action.payload;
			state.loading = false;
		},
		setCurrentTest: (state, action) => {
			state.currentTest = action.payload;
		},
		addTest: (state, action) => {
			state.tests.push(action.payload);
		},
		updateTest: (state, action) => {
			const index = state.tests.findIndex(
				(t) => t.id === action.payload.id,
			);
			if (index !== -1) {
				state.tests[index] = {
					...state.tests[index],
					...action.payload,
				};
			}
			if (state.currentTest?.id === action.payload.id) {
				state.currentTest = { ...state.currentTest, ...action.payload };
			}
		},
		deleteTest: (state, action) => {
			state.tests = state.tests.filter((t) => t.id !== action.payload);
			if (state.currentTest?.id === action.payload) {
				state.currentTest = null;
			}
		},
		setExecutions: (state, action) => {
			state.executions = action.payload;
		},
		addExecution: (state, action) => {
			state.executions.unshift(action.payload);
		},
		updateExecution: (state, action) => {
			const index = state.executions.findIndex(
				(e) => e.id === action.payload.id,
			);
			if (index !== -1) {
				state.executions[index] = {
					...state.executions[index],
					...action.payload,
				};
			}
		},
		setRecording: (state, action) => {
			state.recording = action.payload;
		},
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
		setError: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
	},
});

export const {
	setTests,
	setCurrentTest,
	addTest,
	updateTest,
	deleteTest,
	setExecutions,
	addExecution,
	updateExecution,
	setRecording,
	setLoading,
	setError,
} = testSlice.actions;

export default testSlice.reducer;
